import React, {PureComponent} from 'react';
import {
    Button,
    Col,
    Container,
    Input,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import MenuIcon from 'mdi-react/MenuIcon'
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import {bindActionCreators} from "redux";
import ReactTable from "react-table";
import moment from 'moment';
import { filter, compact } from 'lodash';

import { Icons } from './components/Icons';
import EventFilter from './EventFilter'
import EventTimelineChart from './components/EventTimelineChart'
import {loadAssetEvents, openEvent, removeAssetFilter} from "../../../redux/actions/eventManagement";
import { loadCollections } from '../../../redux/actions/collections';
import { loadAssetTypes } from "../../../redux/actions/entity_types";
import { loadComponentType, loadComponentsByPage } from "../../../redux/actions/componentActions";

class InfiniteScrollExtend extends InfiniteScroll{
  componentDidUpdate(prevProps, prevState){
    if(prevProps.pageStart !== this.props.pageStart){
      this.pageLoaded = 1;
    }
    this.attachScrollListener();
  }
}

class AssetEvents extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hasMoreItems: true,
            viewType: 'list',
            modal: false,
            timelineStartRange: false,
            timelineEndRange: false,
            selectedFilteredComponent: false,
            sortBy: false,
            pageStart: 0
        };
        this.options = {
            onRowClick: (row) => this.rowClickHandler(row)
        };
    };

    componentDidMount() {
        const {
            assetsPredictionFilterFieldData,
            loadCollections,
            loadAssetTypes,
            loadComponentType,
        } = this.props;
        const includePendingCcount=1;

        loadCollections();
        loadAssetTypes();
        loadComponentType();
        this.props.loadAssetEvents({
            includePendingCcount,
            filterFieldData: assetsPredictionFilterFieldData
        });
    }

    componentWillReceiveProps(nextProps){
        const { currentPage, totalPage } = nextProps;
        if (currentPage ==1 && totalPage >0){
            const { pageStart } = this.state;
            this.setState({  pageStart: pageStart === 1 ? 0 : 1 });
            this.setState({
                 hasMoreItems:true,
            })
        }
    }

    rowClickHandler = row => {
        this.props.openEvent(row);
        this.props.history.push('/event_feedback_report');
    };

    toggleModel = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    };

    moreLoader = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> {this.props.t('asset_events.loading_more_events')}
        </div>
    );

    PendingReviewSummery = () => {
        const { t } = this.props;
        return (
          <div className="title-details normal-t-b-space">
              <div className="col-lg-6 col-sm-6 col-xs-12">
                  <h5>{t('asset_events.no_of_event_pending_review')}: <span>{this.props.pendingEventCount}</span></h5>
              </div>
              <div className="col-lg-6 text-right col-sm-6 col-xs-12">
                  <h6>
                      <span><i className="fa fa-circle active" aria-hidden="true" />{t('asset_events.pending_review')}</span>
                      <span><i className="fa fa-circle " aria-hidden="true" />{t('asset_events.reviewed')}</span>
                  </h6>
              </div>
          </div>
        );
    };

    sortByChangeHandler = e => {
        const { loadAssetEvents, assetsPredictionFilterFieldData } = this.props;
        const sortBy = e.target.value;

        this.setState(
          { sortBy },
          () => loadAssetEvents({
              filterFieldData: assetsPredictionFilterFieldData,
              sortBy,
          })
        );
    };

    alterString = function(str) {
        return str && str.length > 0  && str.replace(/_/g,' ').toLowerCase()
          .replace(/^.|\s\S/g, function(a) {
              return a.toUpperCase();
          })
    };

    eventSortingBar = () => {
        const { t, assetsPredictionFilterFieldData, removeAssetFilter } = this.props;
        let filterLabelArray = assetsPredictionFilterFieldData ? assetsPredictionFilterFieldData.split('&') : [];
        filterLabelArray = compact(filterLabelArray);
        const labelData = {
            "review_status" : "Action Status",
            "last_ai_confidence" : "AI Confidence",
            "collection_name" : "Collection",
            "parent_source_name" : "Asset",
            "event_type" : "Event Type",
            "first_seen" : "First Seen",
            "last_seen" : "Last Seen",
            "severity" : "Severity"
        };

        let selectedSource = [];
        filter(filterLabelArray, (filterLabel) => {
            const key = filterLabel.substring(0, filterLabel.indexOf('='));
            const value = filterLabel.substring(filterLabel.indexOf('=') + 1);

            if (key === 'first_seen' || key === 'last_seen') {
                selectedSource.push({
                    label: labelData[key],
                    value: moment(value).format('YYYY-MM-DD'),
                    key
                });
            } else {
                selectedSource.push({
                    label: labelData[key],
                    value: this.alterString(value),
                    key
                });
            }
        });

        return(
            <div className="title-details">
            <div className="col-lg-6 col-sm-6 col-xs-12">
                {selectedSource.map((item)=>
                    <a href="#" className="btn-primary">
                        {t(`asset_events.filter_label.${item.key}`)} : {item.value}
                        <img onClick={()=> removeAssetFilter(item.key)} src="img/close.png" alt=""/>
                    </a>
                )}
            </div>
            <div className="col-lg-6 text-right col-sm-6 col-xs-12">
                <ul>
                    <li><a href="#"><b>{t('asset_events.view')}</b></a></li>
                    <li>
                        <a href="javascript:void(0);" onClick={() => this.setState({viewType : 'list'})}>
                            <MenuIcon />{t('asset_events.list')}
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" onClick={this.timelineMenuClickHandler}>
                            <i className="fa fa-th-large" aria-hidden="true" /> {t('asset_events.timeline_label')}
                        </a>
                    </li>
                    <li className="sort"><a href="#"><b>{t('asset_events.sort_by')}</b></a></li>
                    <li>
                        <Input
                          type="select" bsSize="sm"
                          className={"sort-by-dropdown"}
                          onChange={this.sortByChangeHandler}
                        >
                            <option value=''>Select</option>
                            <option value={'last_seen'}>Last Seen</option>
                            <option value={'first_seen'}>First Seen</option>
                            <option value={'parent_source_name'}>Asset Name</option>
                            <option value={'source_name'}>Component Name</option>
                        </Input>
                    </li>
                </ul>
            </div>
        </div>
      )
    };

    timelineMenuClickHandler = () => {
        this.props.removeAssetFilter('resetAll')
        this.props.loadComponentsByPage({perPage: 10, page: 1, paginationType: 'normal_pagination'});
        this.toggleModel();
    };

    headerSummery = () => {
        const { selectedFilteredComponent } = this.state;
        return (
          <div className="title-details normal-t-b-space">
              <div className="col-lg-6 col-sm-6 col-xs-12">
                  <h4>
                      Event Timeline for {" "}
                      {selectedFilteredComponent && selectedFilteredComponent.asset_name }
                      :
                      {selectedFilteredComponent && selectedFilteredComponent.component_name}
                  </h4>

              </div>
              <div className="col-lg-6 text-right col-sm-6 col-xs-12">
                  <ul>
                      <li><a href="#"><b>View</b></a></li>
                      <li>
                          <a href="javascript:void(0);" onClick={() => this.setState({viewType : 'list'})}>
                              <MenuIcon />List
                          </a>
                      </li>
                      <li>
                          <a href="javascript:void(0);">
                              <i className="fa fa-th-large" aria-hidden="true" /> Timeline
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
        );
    };

    callLoadMore = (page) => {
        const { sortBy } = this.state;
        const { totalPage, assetsPredictionFilterFieldData } = this.props;
        if(totalPage >= page) {
            this.props.loadAssetEvents({
                filterFieldData: assetsPredictionFilterFieldData,
                page,
                sortBy
            });
        } else {
            this.setState({
                hasMoreItems:false,
            })
        }
    };

    reactTableFetchDataHandler = (state, instance) => {
        const { loadComponentsByPage } = this.props;
        let filterFieldData = '';
        state.filtered.filter(columnName =>
          filterFieldData = filterFieldData + '&' + columnName.id + '=' + columnName.value);

        const sortBy =
          state.sorted && state.sorted.length > 0 && state.sorted[0].id
            ? state.sorted[0].id : '';

        loadComponentsByPage({
            page: state.page ? state.page + 1 : 1,
            perPage: state.pageSize ? state.pageSize : 10,
            filterFieldData,
            sortBy,
            paginationType: 'normal_pagination'
        });
    };

    trPropsHandler = (state, rowInfo) => {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: e => {
                    this.setState({
                        rowEdit: rowInfo.index,
                        selectedFilteredComponent: rowInfo.original,
                    });
                },
                style: {
                    background:
                      rowInfo.index === this.state.rowEdit ? "#00afec" : "white",
                    color:
                      rowInfo.index === this.state.rowEdit ? "white" : "black"
                }
            };
        } else {
            return {};
        }
    };

    showTimeLineClickedHandler = () => {
        const { selectedFilteredComponent } =  this.state;
        const { loadAssetEvents } =  this.props;

        if (selectedFilteredComponent && Object.keys(selectedFilteredComponent).length > 0) {
            let filterFieldData =
              selectedFilteredComponent._id
                ? `&source_type=COMPONENT&source_id=${selectedFilteredComponent._id}`
                : '';

            loadAssetEvents({
                filterFieldData
            });

            this.setState({
                viewType: 'timeline',
                modal: false,
            });
        }
    };

    LoadingIEvents = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> {this.props.t('asset_events.loading_events')}
        </div>
    );

    noEventData = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> No events found!
        </div>
    );

    render() {
        const {
            t, loadingAssetsEvent, assetsEvent, totalPage,
            collections, asset_types, component_types, componentPages,
        } = this.props;
        const {
            hasMoreItems, viewType, selectedFilteredComponent,
            sortBy, pageStart
        } = this.state;

        const columns = [
            {
                Header: t('asset_events.asset_labels.component_name'),
                accessor: 'component_name',
            },
            {
                Header: t('asset_events.asset_labels.asset_name'),
                accessor: 'asset_name',
            },
            {
                Header: t('asset_events.asset_labels.collection'),
                accessor: 'collection_name',
                Filter: ({ filter, onChange }) =>
                  <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "all"}
                    className={'table-filter-dropdown'}
                  >
                      <option value="">Show All</option>
                      {
                          collections && collections.length > 0 &&
                          collections.map( (collection, collectionIndex) =>
                            <option key={ collectionIndex } value={ collection.collection_name }>
                                { collection.collection_name }
                            </option>
                          )
                      }
                  </select>
            },
            {
                Header: t('asset_events.asset_labels.asset_type'),
                accessor: 'asset_type_name',
                Filter: ({ filter, onChange }) =>
                  <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "all"}
                    className={'table-filter-dropdown'}
                  >
                      <option value="">Show All</option>
                      {
                          asset_types && asset_types.length > 0 &&
                          asset_types.map( (assetType, assetTypeIndex) =>
                            <option key={ assetTypeIndex } value={ assetType.name }>
                                { assetType.name }
                            </option>
                          )
                      }
                  </select>
            },
            {
                Header: t('asset_events.asset_labels.severity'),
                accessor: 'aggregate_severity',
                Filter: ({ filter, onChange }) =>
                  <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "all"}
                    className={'table-filter-dropdown'}
                  >
                      <option value="">Show All</option>
                      <option value="critical">Critical</option>
                      <option value="minor">Minor</option>
                      <option value="major">Major</option>
                      <option value="normal">Normal</option>
                  </select>
            },
            {
                Header: t('asset_events.asset_labels.component_type'),
                accessor: 'component_type_name',
                Filter: ({ filter, onChange }) =>
                  <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "all"}
                    className={'table-filter-dropdown'}
                  >
                      <option value="">Show All</option>
                      {
                          component_types && component_types.length > 0 &&
                          component_types.map( (componentType, componentTypeIndex) =>
                            <option key={ componentTypeIndex } value={ componentType.name }>
                                { componentType.name }
                            </option>
                          )
                      }
                  </select>
            },
        ];

        function severityLabel (val) {
            let color = '';
            switch (val) {
                case 'CRITICAL' :
                    color = '';
                    break;
                case 'MAJOR' :
                    color = 'orange';
                    break;
                case 'MINOR' :
                    color = 'yellow';
                    break;
                case 'NORMAL' :
                    color = 'green';
                    break;
                default:
                    color = '';
            }
            return color;
        }
        function valueFeverity(cell) {
            return <mark className={severityLabel(cell)}>{cell}</mark>;
        }
        function componetFormate(cell,row) {
            return <React.Fragment><b>{row.source_name}</b><br/>{cell}</React.Fragment>;
        }
        function assetsFormate(cell,row) {
            return <React.Fragment><b>{cell}</b><br/>{row.parent_source_type_name}</React.Fragment>;
        }

        function valueAiConfidence(cell) {
            return <React.Fragment><div className={cell==='LOW'?'red-circle':(cell==='MEDIUM'?'yellow-circle':'green-circle')} />{cell}</React.Fragment>
        }

        const valueEventType = (cell,{event_type, event_label}) => {
            return (
              <React.Fragment>
                    <span>
                        <Icons name={event_type} />
                    </span>
                    <b>{cell}</b><br/>{event_label}
              </React.Fragment>
            )
        };

      function columnClassNameFormat(fieldValue, row) {
        return row.review_status === 'PENDING' ? 'event-status-pending' : 'td-column-function-odd-example';
      }


    return(<Container id="content">
        <Row>
            <Col md={12}>
                <h3 className="page-title"> {t('asset_events.title')}</h3>
            </Col>
        </Row>

        <Row>
            <EventFilter
              onChange={() => this.setState({viewType: 'list'})}
              sortBy={sortBy}
            />

            <div className="row field number full-width">
                <div className="col-lg-12 col-xs-12 col-sm-12">
                    <div className="white-bg">
                        {viewType && viewType === 'timeline' ?
                            this.headerSummery()
                            : this.PendingReviewSummery()
                        }

                        {viewType && viewType === 'list' && !loadingAssetsEvent && totalPage >0 &&
                          <React.Fragment>
                              {this.eventSortingBar()}
                              <div className="pro space-top-0 events">
                                  <div className="table-responsive">
                                      <InfiniteScrollExtend
                                        pageStart={pageStart}
                                        loadMore={this.callLoadMore}
                                        hasMore={hasMoreItems}
                                        loader={this.moreLoader()}
                                      >
                                          {viewType && viewType === 'list' &&
                                          <BootstrapTable
                                            data={assetsEvent}
                                            options={this.options}
                                            striped
                                            hover
                                            condensed
                                            responsive
                                            trClassName="trClassFormat"
                                            tableBodyClass="spacingBorder"
                                            tableContainerClass="tableContainer table-responsive"
                                            tableHeaderClass="tableHeader"
                                            bordered={false}

                                          >
                                              <TableHeaderColumn
                                                dataSort
                                                dataField="display_event_type"
                                                dataFormat={valueEventType}
                                                width="25%"
                                                columnClassName={ columnClassNameFormat }
                                              >
                                                  {t('asset_events.asset_labels.event_type')} /
                                                  {t('asset_events.asset_labels.label')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn
                                                dataSort
                                                dataField="parent_source_name"
                                                dataFormat={assetsFormate}
                                                width="15%"
                                              >
                                                  {t('asset_events.asset_labels.asset_name')} /
                                                  {t('asset_events.asset_labels.type')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn
                                                dataSort
                                                dataField="source_type_name"
                                                dataFormat={componetFormate}
                                                width="15%"
                                              >
                                                  {t('asset_events.asset_labels.component')} /
                                                  {t('asset_events.asset_labels.type')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn
                                                dataSort
                                                dataField="last_seen"
                                                dataFormat={cell => moment.unix(cell).format('YYYY-MM-DD HH:mm:ss')}
                                                width="15%"
                                              >
                                                  {t('asset_events.asset_labels.last_seen')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn
                                                dataSort
                                                dataFormat={valueAiConfidence}
                                                dataField="last_ai_confidence"
                                                width="10%"
                                              >
                                                  {t('asset_events.asset_labels.ai_confidence')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn
                                                dataSort
                                                dataFormat={valueFeverity}
                                                dataField="severity"
                                                width="10%"
                                              >
                                                  {t('asset_events.asset_labels.severity')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn
                                                dataSort
                                                dataField="review_status"
                                                width="10%"
                                              >
                                                  {t('asset_events.asset_labels.action')}
                                              </TableHeaderColumn>
                                              <TableHeaderColumn isKey dataField="_id" dataSort hidden={true}></TableHeaderColumn>
                                          </BootstrapTable>
                                          }
                                      </InfiniteScrollExtend>
                                  </div>
                              </div>
                          </React.Fragment>
                        }

                        {viewType && viewType === 'timeline' && !loadingAssetsEvent &&
                          <EventTimelineChart
                            timelineData={assetsEvent}
                          />
                        }
                        {loadingAssetsEvent &&
                          this.LoadingIEvents()
                        }

                        {totalPage==0 &&
                          this.noEventData()
                        }

                    </div>
                </div>
            </div>
        </Row>
        <Modal isOpen={this.state.modal} toggle={this.toggleModel} className={"asset-list-popup"}>
            <ModalHeader toggle={this.toggleModel}>
                {t('asset_events.timeline.filter_popup.title')}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col className={'title'}>
                        {t('asset_events.timeline.filter_popup.sub_title')}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ReactTable
                          data={componentPages}
                          columns={columns}
                          className='custom-table'
                          filterable
                          minRows = {0}
                          defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value}
                          loading={loadingAssetsEvent}
                          showPagination={true}
                          showPaginationTop={false}
                          showPaginationBottom={true}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                          pages={
                              totalPage ? totalPage : 1
                          }
                          manual
                          onFetchData={(state, instance) => this.reactTableFetchDataHandler(state, instance)}
                          getTrProps={(state, rowInfo) => this.trPropsHandler(state, rowInfo)}
                          />
                    </Col>
                </Row>

                <Row>
                    <Col className={'footer-container'}>
                        <Button
                          color="primary" type="submit"
                          disabled={!selectedFilteredComponent}
                          onClick={this.showTimeLineClickedHandler}
                        >
                            {t('asset_events.timeline.filter_popup.show_timeline')}
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    </Container>)
    }
}

AssetEvents.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    loadAssetsEvent: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    eventsPredictionTimelineData: PropTypes.object,
};

function mapStateToProps({
     eventManagement, collections, asset_types, component,
}) {
    return {
        loadingAssetsEvent : eventManagement.loadingAssetsEvent,
        assetsEvent: eventManagement.assetsEvent,
        currentPage: eventManagement.currentPage,
        totalPage: eventManagement.totalPage,
        assetsEventLabel: eventManagement.assetsEventLabel,
        pendingEventCount: eventManagement.pendingEventCount,
        assetsPredictionFilterFieldData: eventManagement.assetsPredictionFilterFieldData,
        componentPages: component.componentPages,
        component_types: component.component_types,
        collections,
        asset_types,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadAssetEvents,
            loadCollections,
            loadAssetTypes,
            loadComponentType,
            openEvent,
            loadComponentsByPage,
            removeAssetFilter,

        },
        dispatch
    );
}

export default withTranslation('common') (
    connect(
    mapStateToProps,
    mapDispatchToProps
    )(AssetEvents)
);
